
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import OrderLocationDetails from '@/components/OrderLocationDetails.vue';
import ProductsSummary from '@/components/ProductsSummary.vue';
import BasketModule from '@/store/modules/basket';
import UserModule from '@/store/modules/user';
import { hideCMSContent } from '@/utils/global.util';

@Component({
  components: {
    OrderLocationDetails,
    ProductsSummary
  }
})
export default class FavoriteOrder extends Vue {
  @InjectReactive('progressRef') progressRef: any;
  @Getter activeRestaurant!: Restaurant;

  @Prop({ type: Number, default: null }) id: number;
  @Prop({ type: Boolean, default: false }) isDefault: boolean;
  @Prop({ type: String, default: '' }) name: string;
  @Prop({ type: Array, default: () => [] }) products: FavoriteOrderProductModel[];
  @Prop({ type: Number, default: null }) vendorId: number;
  @Prop({ type: String, default: '' }) vendorName: string;

  mounted() {
    this.$scrollTo(this.progressRef as Element);
  }

  async submitHandler() {
    const loader = this.$loading.show();
    try {
      hideCMSContent();
      await BasketModule.createBasketFromFavorite({ favoriteId: this.id });

      this.$router.push(
        {
          name: 'OrderSummary',
          params: {
            ...this.$route.params,
            location: this.activeRestaurant.slug
          }
        });
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }

  async removeFavorite() {
    const loader = this.$loading.show();
    try {
      await UserModule.removeFavoriteOrder(this.id);
      this.$emit('close-preview');
    } catch (err) {
      this.$log.error(err);
      this.$toasted.error(err.data);
    } finally {
      loader.hide();
    }
  }

  getChoices(product) {
    return product.choices.map(p => p.name).join(', ');
  }
}
